import { render, staticRenderFns } from "./MyRegisterStatistics.vue?vue&type=template&id=78e16206&scoped=true"
import script from "./MyRegisterStatistics.vue?vue&type=script&lang=js"
export * from "./MyRegisterStatistics.vue?vue&type=script&lang=js"
import style0 from "./MyRegisterStatistics.vue?vue&type=style&index=0&id=78e16206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e16206",
  null
  
)

export default component.exports